export default __webpack_public_path__ + "static/media/013_photo.b6f41286.jpg";